import Vue from 'vue'
import Vuex from 'vuex'
import defaultAvatar from '@/assets/images/avatar1.png'
Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    sessionToken: null,
    user: null,
    device: null,
    sidebarOpened: true,
    thisYear: 2019,
    finishProductKey: '', // 成方配比树形结构默认选中key
    batchingFinishProductUnKe: '', // 未添加配方树形结构默认选中key
    batchingFinishProduct: '', // 配样管理下成品配方树形结构默认选中key
    partsKey: '', // 半成品管理树形结构默认选中key
    indexUpdate: 'no',
  },
  getters: {
    nickname (state) {
      return state.user ? state.user.name ? state.user.name : state.user.username : '未登录'
    },
    avatar (state) {
      return (state.user && state.user.avatar) || defaultAvatar
    }
  },
  mutations: {
    setSidebarOpened (state, sidebarOpened) {
      state.sidebarOpened = sidebarOpened
    },
    setDevice (state, device) {
      state.device = device
    },
    setSessionToken (state, sessionToken) {
      state.sessionToken = sessionToken
    },
    setUser (state, user) {
      state.user = user
    },
    setYear (state, thisYear) {
      state.thisYear = thisYear
    },
    initFromStorage (state, opt) {
      for (let i in opt) {
        state[i] = opt[i]
      }
    },
    setFinishProductKey (state, key) {
      state.finishProductKey = key
    },
    setFinishSurchargeKey (state, key) {
      state.finishSurchargeKey = key
    },
    setBatchingFinishProductUnKe (state, key) {
      state.batchingFinishProductUnKe = key
    },
    setBatchingFinishProduct (state, key) {
      state.batchingFinishProduct = key
    },
    setPartsKey (state, key) {
      state.partsKey = key
    },
    setBatchingSurcharge (state, key) {
      state.batchingSurcharge = key
    },
    setIndexUpdate (state, key) {
      state.indexUpdate = key
    }

  },
  actions: {}
})
export default store
